import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'
import { WrappingTypesService } from 'src/services/data/wrapping-types.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { createWrappingType, createWrappingTypeFailure, createWrappingTypeSuccess, deleteWrappingType, deleteWrappingTypeFailure, deleteWrappingTypeSuccess, loadWrappingTypes, loadWrappingTypesFailure, loadWrappingTypesSuccess, updateWrappingType, updateWrappingTypeFailure, updateWrappingTypeSuccess } from './wrapping-type.actions'

@Injectable()
export class WrappingTypeEffects {
  private actions$ = inject(Actions)
  private WrappingTypes = inject(WrappingTypesService)
  private toaster = inject(ToasterService)


  loadWrappingTypes$ = createEffect(() => this.actions$.pipe(
    ofType(loadWrappingTypes),
    switchMap(() =>
      from(this.WrappingTypes.getWrappingTypes()).pipe(
        map(wrappingTypes => loadWrappingTypesSuccess({ wrappingTypes: wrappingTypes })),
        catchAndLog(this.toaster, 'Unable to fetch wrappingTypes', loadWrappingTypesFailure)))))

  createWrappingType$ = createEffect(() => this.actions$.pipe(
    ofType(createWrappingType),
    tap(() => this.toaster.progress('Creating wrapping type...')),
    switchMap(action =>
      from(this.WrappingTypes.create(action.wrappingType)).pipe(
        map(wrappingType => createWrappingTypeSuccess({ wrappingType })),
        tap(() => this.toaster.success('Wrapping type created successfully.')),
        catchAndLog(this.toaster, 'Unable to create wrapping type', createWrappingTypeFailure)))))

  updateWrappingType$ = createEffect(() => this.actions$.pipe(
    ofType(updateWrappingType),
    tap(() => this.toaster.progress('Updating wrapping type...')),
    switchMap(action =>
      from(this.WrappingTypes.update({ ...action.wrappingType, wrapping_id: action.id })).pipe(
        map(wrappingType => updateWrappingTypeSuccess({ wrappingType })),
        tap(() => this.toaster.success('Wrapping type updated successfully.')),
        catchAndLog(this.toaster, 'Unable to update wrapping type', updateWrappingTypeFailure)))))

  deleteWrappingType$ = createEffect(() => this.actions$.pipe(
    ofType(deleteWrappingType),
    tap(() => this.toaster.progress('Deleting wrapping type...')),
    switchMap(action =>
      from(this.WrappingTypes.remove(action.id)).pipe(
        map(() => deleteWrappingTypeSuccess({ id: action.id })),
        tap(() => this.toaster.success('Wrapping type deleted successfully.')),
        catchAndLog(this.toaster, 'Unable to delete wrapping type', deleteWrappingTypeFailure)))))
}
